export default "__VITE_ASSET__CwuUT9VT__"